// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3589":"4fbb37ea","5355":"9b9d0867"}[chunkId] + ".chunk.css";
};